import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LwFormNumberInput } from 'redesign';
import { PreferredWorkerFormContext } from '../preferred-worker.types';

type Props = {
  index: number;
  disabled?: boolean;
};

export const ConditionTimeInput = ({ index, disabled }: Props) => {
  const { control } = useFormContext<PreferredWorkerFormContext>();
  const { t } = useTranslation('web-common');

  return (
    <LwFormNumberInput
      name={`visibilityRules.${index}.durationCondition`}
      label={t('work-form.preferred-worker.duration-condition.label')}
      control={control}
      disabled={disabled}
      rules={{
        required: t('work-form.preferred-worker.duration-condition.error'),
      }}
      step={1}
      min={1}
    />
  );
};
